// Converted from application/views/sculptures/wind&sea_v.php. Edit this component directly.
export default function SculpturesWindSeaPage() {
  return <><div class={"firstContainer container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/wind&sea/wind&sea-cover-full.jpg"} alt={"Wind & Sea"} />
<figcaption>{"#1"}</figcaption>
</figure>
<div class={"text"}>
<div>
<div class={"mainTitleWrp"}>
<h1>{"Wind & Sea "}<small>{"(XL)"}</small></h1>
<p>
<b>{"4.30m in height"}</b><br />{"\n                        13 feet"}<br />{"\n                        Bronze"}<br />{"\n                        No. in Series 10\n                "}</p>
</div>
</div>
</div>
</div>
<div class={"container photoRight"}>
<div class={"text"}>
<div>
<p>{"\n                Having been born and reared in Ireland, my senses are forever stirred by the relentless winds and waves sweeping in from the Atlantic Ocean.\n            "}</p>
<p>{"\n                From the time I started sculpting, I yearned to capture the interplay between these two elements in figurative forms.\n            "}</p>
</div>
</div>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/wind&sea/wind&sea-cover.jpg"} alt={"Wind & Sea Closeup"} />
<figcaption>{"#2"}</figcaption>
</figure>
</div>
<div class={"container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/wind&sea/wind&sea-closeup2.jpg"} alt={"Wind & Sea Closeup"} />
<figcaption>{"#3"}</figcaption>
</figure>
<div class={"text"}>
<div>
<p>{"\n                My initial concept was a wax maquette which featured a female dancer ("}<b>{"Wind"}</b>{") facing a male dancer ("}<b>{"Sea"}</b>{") and “jiving” together, to convey movement, interactivity, turbulence, energy, and unpredictability – features of a tempestuous relationship!\n            "}</p>
<p>{"\n                Then one day, as happens sometimes in art, the idea seemed to take over, and take charge.  As I turned the figures back-to-back they somehow clicked, head to head, with hands stretched outwards and upwards.\n            "}</p>
</div>
</div>
</div>
<div class={"container photoRight"}>
<div class={"text"}>
<div>
<p>{"\n                I knew immediately that this was just as it was meant to be, and I committed to making this monumental bronze sculpture 1.5 times lifesize (4.5m/16ft. high) called “Wind and Sea”\n            "}</p>
<p>{"\n                My two dedicated models, Sara and Claudio, were accomplished actors, who held the difficult poses as we worked in my studio at via Luna, Florence.  Most often, I found that actors could play the part of a vital subject better than most.\n            "}</p>
</div>
</div>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/wind&sea/wind&sea-closeup3.jpg"} alt={"Wind & Sea Closeup"} />
<figcaption>{"#4"}</figcaption>
</figure>
</div>
<div class={"container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/wind&sea/wind&sea-closeup4.jpg"} alt={"Wind & Sea Closeup"} />
<figcaption>{"#5"}</figcaption>
</figure>
<div class={"text"}>
<div>
<p>{"\n                My moment of apprehension turned to elation on D-day in the foundry when the two giant bronze figures came together, connected, and were fused in only three places.   They looked exactly as I imagined they should.\n            "}</p>
<p>{"\n                The first of the edition became the centrepiece of the “Di Cuore” (From the Heart) Exhibition at Palazzo Medici Riccardi in Florence in the summer of 2013, and was acquired by University College Dublin to be installed on their campus IN November that year.\n            "}</p>
</div>
</div>
</div>
<div class={"container photoRight"}>
<div class={"text"}>
<div>
<p>{"\n                The second I brought back to Ireland, and it is installed in our garden close to Dublin Airport.\n            "}</p>
<p>{"\n                The third (currently featuring in the Galeria Frilli Exhibition in The Four Seasons Hotel in Florence) was installed in the Piazza del Duomo, Pietrasanta in 2018, as part of “il Dolce Rumore Della Vita” (the Sweet Noise of Life) Exhibition.\n            "}</p>
</div>
</div>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/wind&sea/wind&sea-detail.jpg"} alt={"Wind & Sea Detail"} />
<figcaption>{"#6"}</figcaption>
</figure>
</div>
<h2 style={{"textAlign":"center","marginBottom":"2rem"}}>{"\n    Wind & Sea (XL) has been installed in:\n"}</h2>
<ul class={"twoColumnsList"}>
<li>
<figure>
<img src={"/assets/images/sculptures/wind&sea/wind&water-dublin.jpg"} alt={"Wind & Sea (XL) Brackenstown House, Swords, Co. Dublin"} />
<figcaption>
<b>{"Wind & Sea"}</b>{" (XL)"}<br />{"\n                Brackenstown House, Swords, Co. Dublin\n            "}</figcaption>
</figure>
</li>
<li>
<figure>
<img src={"/assets/images/sculptures/wind&sea/wind&sea-belfast.jpg"} alt={"Wind & Sea (XL), Belfast"} />
<figcaption>
<b>{"Wind & Sea"}</b>{" (XL)"}<br />{"\n                New Castle, CountryDown, Belfast\n            "}</figcaption>
</figure>
</li>
<li>
<figure>
<img src={"/assets/images/sculptures/wind&sea/wind&sea-dublinuniversity.jpg"} alt={"Wind & Sea (XL), University College Dublin, Ireland"} />
<figcaption>
<b>{"Wind & Sea"}</b>{" (XL)"}<br />{"\n                University College Dublin, Ireland\n            "}</figcaption>
</figure>
</li>
<li>
<figure>
<img src={"/assets/images/sculptures/wind&sea/wind&sea-cork.jpg"} alt={"Wind & Sea (XL), Castlemartyr Exhibition, Cork, Ireland"} />
<figcaption>
<b>{"Wind & Sea"}</b>{" (XL)"}<br />{"\n                Castlemartyr Exhibition, Cork, Ireland\n            "}</figcaption>
</figure>
</li>
<li>
<figure>
<img src={"/assets/images/sculptures/wind&sea/wind&sea-culloden-hotel.jpg"} alt={"Wind & Sea (XL), Culloden Hotel Estate, Belfast, Northern Ireland"} />
<figcaption>
<b>{"Wind & Sea"}</b>{" (XL)"}<br />{"\n                Culloden Hotel Estate, Belfast, Northern Ireland\n            "}</figcaption>
</figure>
</li>
</ul>
</>;
}
